export default $wire => ({
    value: $wire.entangle('value').live,

    isChecked(optionValue) {
        if (typeof this.value == 'boolean') {
            return this.value;
        }

        return this.value.includes(optionValue);
    },
});
